// extracted by mini-css-extract-plugin
export default {"LogIn":"LogIn_LogIn__09z1x","LogIn__Logo":"LogIn_LogIn__Logo__F5edg","LogInForm":"LogIn_LogInForm__lg5BM","LogInForm__Row":"LogIn_LogInForm__Row__GADGz"};